import { ReturnRequestLineItemDto } from "@babackapp/private-api-client/types";
import { getLineItemValidatedByMerchantQuantity } from "./get-line-item-validated-by-merchant-quantity";
import { getLineItemValidatedByLogisticianQuantity } from "./get-line-item-validated-by-logistician-quantity";
import { getLineItemRejectedByMerchantQuantity } from "./get-line-item-rejected-by-merchant-quantity";
import { getLineItemRejectedByLogisticianQuantity } from "./get-line-item-rejected-by-logistician-quantity";

type UseLineItemValidatedMaxQuantityParams = {
  lineItem: ReturnRequestLineItemDto;
};

/**
 * Returns the maximum quantity that a merchant can treat when workflow logistician is activated.
 *
 * The calculation is:
 * - Takes the total quantity validated by logistician
 * - Subtracts the quantity already validated by merchant
 * - Returns the remaining quantity eligible for merchant validation
 *
 * @example
 * If a line item was purchased 4 times:
 * - Logistician validates 2 items
 * - Merchant validates 1 item
 * - Result: 1 item remaining that can be treated by merchant (2 - 1 = 1)
 */
export function getLineItemReadyToBeTreatedByMerchantSelectableQuantityWithWorkflowLogistician({
  lineItem,
}: UseLineItemValidatedMaxQuantityParams) {
  const quantityValidatedByMerchant = getLineItemValidatedByMerchantQuantity({
    lineItem,
  });
  const quantityRejectedByMerchant = getLineItemRejectedByMerchantQuantity({
    lineItem,
  });
  const quantityRejectedByLogistician =
    getLineItemRejectedByLogisticianQuantity({
      lineItem,
    });

  const quantityValidatedByLogistician =
    getLineItemValidatedByLogisticianQuantity({
      lineItem,
    });

  return Math.max(
    quantityValidatedByLogistician +
      quantityRejectedByLogistician -
      (quantityValidatedByMerchant + quantityRejectedByMerchant),
    0,
  );
}
